import Layout from "./components/Layout";
import "./custom.css";
import Alert from '@mui/material/Alert';
import { isDev, isTraining } from "./utilities/general";
import { createTheme, ThemeProvider } from "@mui/material";
import useFeatureFlags from "./hooks/useFeatureFlag";
import Version from "./utilities/version";

const theme = createTheme({
  palette: {
    primary: {
      main: "#3838d0"
    },
    secondary: {
      main: "#de0e0e"
    },
  }
});


const App = () => {
  const featureFlag = useFeatureFlags(Version.getApplicationId()); // Pass in the feature flag ID

  return (
    <ThemeProvider theme={theme}>
      <>
        {isDev() && <Alert variant="filled" severity="warning" >
          RUNNING IN DEV MODE! All changes will affect test database only!
        </Alert>}
        {isTraining() && <Alert variant="filled" severity="info" >
          RUNNING IN TRAINING MODE! All changes will affect training database only!
        </Alert>}
        {featureFlag
          ? <Layout />
          : <div>Loading...</div>
        }
      </>
    </ThemeProvider>
  )
};

export default App;
